import React from 'react';
import AspectRatio from '@mui/joy/AspectRatio';
import Card from '@mui/joy/Card';
import CardContent from '@mui/joy/CardContent';
import CardOverflow from '@mui/joy/CardOverflow';
import Divider from '@mui/joy/Divider';
import { Typography, Container } from '@mui/material';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faProjectDiagram } from '@fortawesome/free-solid-svg-icons';
import { faArrowLeft, faArrowRight } from '@fortawesome/free-solid-svg-icons';
import BookImage from '../assests/images/book.jpg';
import MovieImage from '../assests/images/movie.jpg';
import SparkImage from '../assests/images/spark.jpg';
import DistributedMessanger from "../assests/images/DistributedMessanger.png";
import ImageController from "../assests/images/ImageProcessing.png"
import CloudDevops from "../assests/images/cloudnativedevops.png"
import sparkImage from "../assests/images/spark.png"
import sheltersupport from "../assests/images/homelesssheltermanagement.png"
import sudoku from "../assests/images/sudoku.png"
import linux from "../assests/images/linux.png"
import MystryDungenGame from "../assests/images/mystrydungen.png"
import MusicDatabase from "../assests/images/musicdb.png"
import ComicDb from "../assests/images/comicdb.png"
import slidepuzzlegame from "../assests/images/slidepuzzlegame.png"
import mypiggybank from "../assests/images/mypiggybank.png"
import photoalbum from "../assests/images/easyAnimator.PNG"
import companysalesforecasting from "../assests/images/companysales.png"
import timeseries from "../assests/images/timeseries.png"
import textSummarization from "../assests/images/textsummarization.png"
import questionansweringbot from "../assests/images/qa.png"
import HumanMentalHealthAnalysis from "../assests/images/HumanMentalHealthAnalysis.png"
import AirBNB from "../assests/images/airbnbvisualization.png"
import companysalesforecastingImage from "../assests/images/tableau1.png"
import paintwebapp from '../assests/images/reactpaintwebsite.png'
import paradetect from '../assests/images/Paradetect.png'
import customerprediction from '../assests/images/churn.png'
import projectManagementWebsite from "../assests/images/projectmanagementwebsite.png"
import Moviewebsitemern from "../assests/images/Movie.png"
import restaurantbooking from "../assests/images/restaurantbooking.png"
import TripAdvisor from "../assests/images/Trip.png"
import AutoReplyTwitterhandle from "../assests/images/AutoReplyTwitterhandle.png"
import CourseRecommender from "../assests/images/recommendersystem.png"

const Projects = () => {
  const arrowStyle = {
    position: 'absolute',
    top: '50%',
    transform: 'translateY(-50%)',
    fontSize: '2rem', // Adjust the font size as desired
    cursor: 'pointer',
    zIndex: '1',
  };
  const settings = {
    dots: true,
    infinite: false,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1
  };
 
  const PrevArrow = ({ onClick }) => {
    return (
      <div style={{ ...arrowStyle, left: '-50px' }} onClick={onClick}>
        <FontAwesomeIcon icon={faArrowLeft} />
      </div>
    );
  };
  
  const NextArrow = ({ onClick }) => {
    return (
      <div style={{ ...arrowStyle, right: '10px' }} onClick={onClick}>
        <FontAwesomeIcon icon={faArrowRight} />
      </div>
    );
  };
  
  
  const softwareDevelopment =[

    {
      name: "Distributed Messanger",
      img: DistributedMessanger ,
      // github: "https://github.com/ameyagidh/DistributedMessanger",
      description: "Peer-to-peer chat system,facilitates real-time communication among users. It includes message sending, file sharing, and group chat features. Users can connect via multiple application instances."
    },
   
    {
      name: "Personal Finance Application",
      img: mypiggybank,
      // github: "https://github.com/ameyagidh/MyPiggyBank",
      description: "Led a team to build an expense tracking and budgeting mobile app using Java and firebase, added features like timely reports, personalized dashboard, expense visualization and live news feeds."
    },

    {
      name: "Image Processing software",
      img: ImageController,
      // github: "https://github.com/ameyagidh/ImageProcessingSoftware",
      description: "The Image Manipulation App, Java-based, allows users to manipulate images easily, with features like loading, saving, and applying various processing techniques via an intuitive interface."
    },
    
    {
      name: "Photo Album Software",
      img: photoalbum,
      // github: "https://github.com/ameyagidh/PhotoAlbum",
      description: "The Java project PhotoAlbum utilizes Swing and HTML to create both swing and web views, seamlessly combining them to offer more versatile and interactive user experiences."
    },
    {
      name: "Cloud Native Devops Project",
      img: CloudDevops,
      // github: "https://github.com/ameyagidh/CloudProject",
      description: "SpringBoot web app with automated CI/CD and AMI creation via HCL Packer. CloudFormation templates for infrastructure setup, AWS Lambda for serverless components."
    },

    // {
    //   name: "Shelter Support For Homeless",
    //   img: sheltersupport,
    //   github: "https://github.com/ameyagidh/ShelterSupport",
    //   description: "Nightly, 500,000+ Americans experience homelessness, comprising 0.2% of the US population. Homelessness correlates strongly with health issues. Healthcare system needed."
    // }
     ];

  const dataScienceandML = [
    // {
    //   name: "Twitter Spark Project",
    //   img: sparkImage,
    //   github: "https://github.com/ameyagidh/TwitterSparkProject",
    //   description: "Spring Boot service retrieves data from Spotify, MusixMatch, and Twitter APIs. Scala Spark analyzes text data, computes similarity, and extracts sentiment."
    // },
    
    {
      name: "Customer Retention",
      img: customerprediction,
      // github: "https://github.com/ameyagidh/CustomerRetentionAndChurnPrediction",
      description: "Built comprehensive solutions for customer churn prediction and retention analysis, through EDA and machine learning techniques to optimize business outcomes"
    },
    {
      name: "Airline Twitter Support",
      img: AutoReplyTwitterhandle,
      // github: "https://github.com/ameyagidh/Airline-Twitter-Support",
      description: "Crafted an automated Twitter support system leveraging Kafka, Spark, and LSTM models on AWS to efficiently process live tweets and classify sentiment."
    },
    
    {
      name: "Paraphrased Text Detector",
      img: paradetect,
      // github: " https://github.com/ameyagidh/ParaphrasedTextDetector",
      description: "Built NLP models on Reddit mental health data, involving preprocessing, sentiment analysis, vectorization, embeddings, topic modeling and sequence labeling"
    },
    {
      name: "Human Mental Health Analysis",
      img: HumanMentalHealthAnalysis,
      // github: "https://github.com/ameyagidh/HumanMentalHealthAnalysis",
      description: "LSTM-based model classifies Reddit mental health posts by severity. Achieves X% accuracy. Requires Python, TensorFlow, Keras, Gensim, NLTK, Pandas, NumPy."
    },
 
    {
      name: "Company Sales forecasting",
      img: companysalesforecasting,
      // github: "https://github.com/ameyagidh/CompanySalesForecasting",
      description: "Project predicts sales using SARIMA model after EDA. SARIMA manages trend and seasonal data effectively, enhancing time series forecasting accuracy."
    },

    // {
    //   name: "Human Mental Health Analysis",
    //   img: HumanMentalHealthAnalysis,
    //   github: "https://github.com/ameyagidh/HumanMentalHealthAnalysis",
    //   description: "LSTM-based model classifies Reddit mental health posts by severity. Achieves X% accuracy. Requires Python, TensorFlow, Keras, Gensim, NLTK, Pandas, NumPy."
    // },

    // {
    //   name: "Text Summarization Project",
    //   img: textSummarization,
    //   github: "https://github.com/ameyagidh/TextSummarization",
    //   description: "Text Summarization Project employs LSTM, LDA, and potentially BERT models for summarizing text. Includes evaluation using ROUGE metrics. Contributions welcome."
    // },

    // {
    //   name: "Time Series Analysis",
    //   img: timeseries,
    //   github: "https://github.com/ameyagidh/TimeSeriesforecastingFinanceData",
    //   description: "Statistical models, including SARIMA, ETS, and GARCH, forecast S&P 500 Market Index. Prophet from Facebook is explored for forecasting. Data analysis provided."
    // },

    {
      name: "Question Answering Bot",
      img: questionansweringbot,
      // github: "https://github.com/ameyagidh/QuestionAnsweringBot",
      description: "Question Answering Bot utilizes SQuAD 2.0 data for a robust Question Answering system. Features LSTM Seq2Seq model with attention mechanisms and Tkinter GUI."
    },
    {
      name: "AirBNB tableau",
      img: AirBNB,
      // github: "https://github.com/ameyagidh/AirBNBTableauVisualization",
      description: "Airbnb rental market using Tableau, analyzing rental trends, pricing dynamics, and property types and interactive dashboard creation."
    },
    {
      name: "Company Sales tableau",
      img: companysalesforecastingImage,
      // github: "https://github.com/ameyagidh/CompanySalesTableauVisualization",
      description: "Customer Sales Analysis is a visualization project aimed at providing insights into sales data through Tableau, facilitating data-driven decision-making."   },
  ];

   const webDevelopment = [
    {
      name: "Trip Planner and Advisor Website",
      img: TripAdvisor,
      // github: "https://github.com/ameyagidh/TripPlannerWebsite",
      description: "Developed a seamless and intuitive user-friendly travel planner web application using MERN stack, integrating Google Maps APIs for efficient route planning and enhanced user interaction experience"
    },
    {
      name: "Project Management website",
      img: projectManagementWebsite,
      // github: "https://github.com/ameyagidh/ProjectManagementWebsite",
      description: "Built a MERN stack SaaS web app with secured user authentication, interactive Kanban dashboards and breakout rooms for uninterrupted communication for companies to manage their projects efficiently"
    },
    {
      name: "Course Recommender Website",
      img: CourseRecommender,
      // github: "https://github.com/ameyagidh/RecommenderSystem",
      description: "Made a personalized recommendation system for university students using MERN Stack and python programming, employed collaborative filtering approach to suggest and assist them choose courses"
    },
    {
      name: "Restaurant Website",
      img: restaurantbooking,
      // github: "https://github.com/ameyagidh/RestaurantManagementWebsite",
      description: "Developed a restaurant booking full-stack website with precise seat allocation and real-time food order tracking, enhancing customer experience and optimizing restaurant operations."
    },
    {
      name: "Paint React Website",
      img: paintwebapp,
      // github: "https://github.com/ameyagidh/PaintWebapp",
      description: "A web-based painting tool with color selection, brush size adjustment, canvas clearing, and artwork saving functionalities. Built using React, TypeScript, and Tailwind CSS."
    },  
    {
      name: "Algorithms Project",
      img: sudoku,
      // github: "https://github.com/ameyagidh/KnuthAlgorithmSudokuSolver",
      description: "KnuthAlgorithmSudokuSolver: A React web app ingeniously employing Donald Knuth's Dancing Links algorithm for efficient Sudoku puzzle resolution, providing accurate solutions.."
    },
  ];

  const otherProjects = [
    {
      name: "linux",
      img: linux,
      // github: "https://github.com/ameyagidh/Linux-Shell", 
      description: " Mini Shell in C similar to popular shells like Bash. This project acts as a gateway between users and the OS, executing diverse commands ."
    },
    {
      name: "Slide Puzzle Game",
      img: slidepuzzlegame,
      // github: "https://github.com/ameyagidh/Slide-Puzzle-Game",
      description: "Game starts with a splash screen displaying an image. After 3 seconds, user inputs name and moves. Board drawn with turtle library. Player moves, leaders plotted."
    },
    {
      name: "Music Database System",
      img:MusicDatabase,
      // github: "https://github.com/ameyagidh/MusicStreamingDatabase",
      description: "This project provides a MySQL database system to manage music streaming content and developed a flask webapp with interactive GUI"
    },
    {
      name: "Comic Database System",
      img: ComicDb,
      // github: "https://github.com/ameyagidh/MyComicDatabase",
      description: "Application's database design has structured tables for manga details, publishers, authors, users, and more, ensuring data integrity and smooth retrieval"
    },
    {
      name: "Mystry Dungen Game",
      img: MystryDungenGame,
      // github: "https://github.com/ameyagidh/DungeonMysteryGame",
      description: "Welcome to Mystery Dungeon Game! Embark on a text-based adventure. Explore dungeons, gather treasures, fight monsters, and strive to survive!"
    },

  ];

  return (
<Container sx={{ paddingTop: '20px', paddingBottom: '20px' }} id='projects'>
  <Typography variant="h4" align='center'>
    <FontAwesomeIcon icon={faProjectDiagram} /> Software Projects
  </Typography>
  <div className='w-full m-auto'> {/* Adjusted width to 'w-full' */}
    <Slider {...settings} {...settings} prevArrow={<PrevArrow />} nextArrow={<NextArrow />}>
      {softwareDevelopment.map((d, index) => (
        <div key={index}> {/* Removed margin from the div */}
          <Card variant="outlined" sx={{ width: 320 }}>
            <CardOverflow>
              <AspectRatio ratio="1.5">
                <img
                  src={d.img}
                  loading="lazy"
                  alt=""
                />
              </AspectRatio>
            </CardOverflow>
            <CardContent>
              <Typography variant="body2" color="text.secondary">
                {d.description}
              </Typography>
              <Typography level="title-md">{d.name}</Typography>
            </CardContent>
            {/* <CardOverflow variant="soft" sx={{ bgcolor: 'background.level1' }}>
              <Divider inset="context" />
              <CardContent orientation="horizontal">
                <Typography level="body-xs" fontWeight="md" textColor="text.secondary">
                  <a href={d.github}>GitHub</a>
                </Typography>
              </CardContent>
      </CardOverflow> */}
          </Card>
        </div>
      ))}
    </Slider>
  </div>

  &nbsp;
  &nbsp;
  <Typography variant="h4" align='center'>
    <FontAwesomeIcon icon={faProjectDiagram} /> Data Science and Machine Learning Projects
  </Typography>
  <div className='w-1/2 m-auto'>
  <Slider {...settings}prevArrow={<PrevArrow />} nextArrow={<NextArrow />}>
    {dataScienceandML.map((d, index) => ( // Added index as a parameter
      <div key={index} style={{ margin: '0 10px' }}> {/* Added a div with margin */}
        <Card variant="outlined" sx={{ width: 320 }}>
          <CardOverflow>
            <AspectRatio ratio="1">
              <img
                src={d.img}
                loading="lazy"
                alt=""
              />
            </AspectRatio>
          </CardOverflow>
          <CardContent>
            <Typography variant="body2" color="text.secondary">
              {d.description}
            </Typography>
            <Typography level="title-md">{d.name}</Typography>
          </CardContent>
        {/* <CardOverflow variant="soft" sx={{ bgcolor: 'background.level1' }}>
            <Divider inset="context" />
            <CardContent orientation="horizontal">
              <Typography level="body-xs" fontWeight="md" textColor="text.secondary">
                <a href={d.github}>GitHub</a>
              </Typography>
            </CardContent>
          </CardOverflow> */}
        </Card>
      </div>
    ))}
  </Slider>
</div>

  &nbsp;
  &nbsp;
  <Typography variant="h4" align='center'>
  <FontAwesomeIcon icon={faProjectDiagram} /> Websites Projects
</Typography>
<div className='w-1/2 m-auto'>
  <Slider {...settings}prevArrow={<PrevArrow />} nextArrow={<NextArrow />}>
    {webDevelopment.map((d, index) => ( // Added index as a parameter
      <div key={index} style={{ margin: '0 10px' }}> {/* Added a div with margin */}
        <Card variant="outlined" sx={{ width: 320 }}>
          <CardOverflow>
            <AspectRatio ratio="1">
              <img
                src={d.img}
                loading="lazy"
                alt=""
              />
            </AspectRatio>
          </CardOverflow>
          <CardContent>
            <Typography variant="body2" color="text.secondary">
              {d.description}
            </Typography>
            <Typography level="title-md">{d.name}</Typography>
          </CardContent>
          {/*  <CardOverflow variant="soft" sx={{ bgcolor: 'background.level1' }}>
            <Divider inset="context" />
            <CardContent orientation="horizontal">
              <Typography level="body-xs" fontWeight="md" textColor="text.secondary">
                <a href={d.github}>GitHub</a>
              </Typography>
            </CardContent>
          </CardOverflow>
          */}
        </Card>
      </div>
    ))}
  </Slider>
</div>
  &nbsp;
  &nbsp;
  <Typography variant="h4" align='center'>
  <FontAwesomeIcon icon={faProjectDiagram} /> Other Projects
</Typography>
<div className='w-1/2 m-auto'>
  <Slider {...settings}prevArrow={<PrevArrow />} nextArrow={<NextArrow />}>
    {otherProjects.map((d, index) => ( // Added index as a parameter
      <div key={index} style={{ margin: '0 10px' }}> {/* Added a div with margin */}
        <Card variant="outlined" sx={{ width: 320 }}>
          <CardOverflow>
            <AspectRatio ratio="1">
              <img
                src={d.img}
                loading="lazy"
                alt=""
              />
            </AspectRatio>
          </CardOverflow>
          <CardContent>
            <Typography variant="body2" color="text.secondary">
              {d.description}
            </Typography>
            <Typography level="title-md">{d.name}</Typography>
          </CardContent>
          {/*<CardOverflow variant="soft" sx={{ bgcolor: 'background.level1' }}>
            <Divider inset="context" />
            <CardContent orientation="horizontal">
              <Typography level="body-xs" fontWeight="md" textColor="text.secondary">
                <a href={d.github}>GitHub</a>
              </Typography>
            </CardContent>
  </CardOverflow> */}
        </Card>
      </div>
    ))}
  </Slider>
</div>

  

</Container>
  );
};

export default Projects;
